<div class="modal-content modal-small">
    <div class="modal-header">
        <div class="col-md-12">
            <i (click)="cancel()" style="cursor: pointer;" data-dismiss="modal" class="fas fa-arrow-left"></i>&nbsp; <strong>Report Question</strong>
        </div>
    </div>
    <div class="row modal-body">
        <div class="col-md-12 text-center">
            <strong>Do you observe any ambiguity in this question<br> and would like to bring in our notice?</strong> 
        </div>                   
    </div>
    <div class="model-footer">
        <div class="col-md-12 text-center" style="margin-bottom:20px;margin-top:20px;">         
            <button type="button" class="btn btn-danger" 
                (click)="Dought_In_Question(0)">No</button> &nbsp;&nbsp;&nbsp;
            <button type="button" class="btn btn-primary pink"
                (click)="Dought_In_Question(1)">Yes</button>
        </div>
    </div>
</div>